import React, { Component, PropTypes } from 'react';
import { get } from 'lodash';
import Status from './StatusComponent';
import { HotelsNetwork } from '../../../../constants/ManageApps';
import StatusMessage from './StatusMessageComponent';
import If from '../../../helpers/if';

class HotelsNetworkSection extends Component {
    render() {
        const status = get(this.props.configurationObject, 'status', 'inherit');
        const chainStatus = get(this.props.chainConfigurationObject, 'status', 'inactive');

        return (
            <section className="content-section hotels-network">
                <Status
                    objectName="thehotelnetwork"
                    value={status}
                    parentValue={chainStatus}
                    level={this.props.level}
                    setValue={(key, value) => {
                        this.props.setValue(key, value);
                    }}
                />
                <StatusMessage appName={HotelsNetwork.appName} value={status} parentValue={chainStatus} />
                <If condition={status === 'active'}>
                    <p className="spark-message__content spark-bold status-message">
                        <a href={HotelsNetwork.consent}>Special offer</a> on activation with The Hotel Network with
                        SynXis. Email 
                        <a href={HotelsNetwork.consent}>partnershipsteam@thehotelsnetwork.com</a> to learn more.
                    </p>
                </If>
            </section>
        );
    }
}

HotelsNetworkSection.propTypes = {
    configurationObject: PropTypes.shape({
        status: PropTypes.string
    }).isRequired,
    chainConfigurationObject: PropTypes.shape({
        status: PropTypes.string
    }),
    level: PropTypes.string,
    setValue: PropTypes.func.isRequired
};

export default HotelsNetworkSection;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/HotelsNetworkSection.js